/**
 * Get the list of categories
 * @param {string} API_BASE - Base API URL
 * @param {string} token - JWT token
 * @param {string} code_etablissement - Establishment code
 * @returns {Promise<Array>} Array of category strings
 */
async function getCategories(API_BASE, token, code_etablissement) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE}/categories?code_etablissement=${code_etablissement}`, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error("Erreur lecture des catégories: " + (await response.text()));
    }

    const categories = await response.json();
    //console.log("Categories retrieved:", categories);

    return Array.isArray(categories) ? categories : [];
}

export default getCategories;
